export enum PanelTypeValues {
  SECURITY = "security", // security
  BLOCKED_LIST = "blocked-list", // blockedList
  NICKNAME_LIST = "nickname-list", // nicknameList
  DEACTIVATE_AND_DELETE = "deactivate-and-delete", // deactivateAndDelete
  D_BOT_PERMISSION = "d-bot-permission", // dBotPermission
  AUDIENCE_SUBSCRIBED = "audience-subscribed", // audience subscribed
  AUDIENCE_REVENUE = "audience-revenue", // audience revenue
  PAY_TO_OPEN_PURCHASED = "pay-to-open-purchased", // pay-to-open purchased items
  PAY_TO_OPEN_SOLD = "pay-to-open-sold", // pay-to-open sold items
}

export function parseSettingsPanel(search: string): PanelTypeValues | null {
  const value = new URLSearchParams(search).get("panel");
  return (
    Object.values(PanelTypeValues).find((panel) => panel === value) ?? null
  );
}
export function buildSettingsSearch(
  search: string,
  panel: PanelTypeValues | null
): string {
  const params = new URLSearchParams(search);
  if (panel === null) params.delete("panel");
  else params.set("panel", panel);
  const query = params.toString();
  return query ? `?${query}` : "";
}
